import React from 'react'
import { Text, View } from 'react-native'
import { useCssStyle } from '../../customHook/getCssStyle';
import { getCleanUrl } from '../../utils/Helper';
import { ImageComp } from '../Image/Image';
import CustomFlatList from '../customFlatList';
import CustomPressable from '../customPressable/customPressable';

const MultiControllerWidget = (props) => {
    const { listItemData, displayName, handleOnWidgetClick } = props || {};
    const getStyles = useCssStyle();


    const renderItem = ({ item }) => (

        <CustomPressable onPress={() => handleOnWidgetClick(item)} style={getStyles(['multiControllerWidgetContainer', `multiControllerWidgetContainer_${item.widgetMetaHtmlId}` ,`multiControllerWidgetContainer_${item.id}`, {borderRadius: 8}])} id={`multiControllerWidgetContainer multiControllerWidgetContainer_${item.widgetMetaHtmlId} multiControllerWidgetContainer_${item.id}`} >
        <>
            <View style={getStyles(['multiControllerWidgetImageStyle', `multiControllerWidgetImageStyle_${item.widgetMetaHtmlId}`, `multiControllerWidgetImageStyle_${item.id}`])} id={`multiControllerWidgetImageStyle multiControllerWidgetImageStyle_${item.widgetMetaHtmlId} multiControllerWidgetImageStyle_${item.id}`}>
                <ImageComp
                source={getCleanUrl(item?.btnImageUrl)}
                style={getStyles(['multiControllerWidgetImage', `multiControllerWidgetImage_${item.widgetMetaHtmlId}`, `multiControllerWidgetImage_${item.id}`])}
                id={`multiControllerWidgetImage multiControllerWidgetImage_${item.widgetMetaHtmlId} multiControllerWidgetImage_${item.id}`}
                />
            </View>

            <View style={getStyles(['multiControllerWidgetTextContainer', `multiControllerWidgetTextContainer_${item.widgetMetaHtmlId}`, `multiControllerWidgetTextContainer_${item.id}`])} id={`multiControllerWidgetTextContainer multiControllerWidgetTextContainer_${item.widgetMetaHtmlId} multiControllerWidgetTextContainer_${item.id}`}>
                {item?.widgetTitle && 
                    <Text 
                        style={getStyles(['multiControllerWidgetTitle', `multiControllerWidgetTitle_${item.widgetMetaHtmlId}`, `multiControllerWidgetTitle_${item.id}`])} numberOfLines={2} 
                        id={`multiControllerWidgetTitle multiControllerWidgetTitle_${item.widgetMetaHtmlId} multiControllerWidgetTitle_${item.id}`}
                    >
                        {item?.widgetTitle}
                    </Text>}

                {item?.widgetDesc && 
                    <Text 
                        style={getStyles(['multiControllerWidgetDescription', `multiControllerWidgetDescription_${item.widgetMetaHtmlId}`, `multiControllerWidgetDescription_${item.id}`])} 
                        id={`multiControllerWidgetDescription multiControllerWidgetDescription_${item.widgetMetaHtmlId} multiControllerWidgetDescription_${item.id}`} numberOfLines={2}
                    >
                        {item?.widgetDesc}
                    </Text>}
            </View>
        </>
        </CustomPressable>
    );

    return (
        <View 
            style={getStyles([
                'multiControllerWidgetMainContainer', 
                `multiControllerWidgetMainContainer_${listItemData[0].widgetMetaHtmlId}`, 
                `multiControllerWidgetMainContainer_${listItemData[0].id}`
            ])} 
            id={`multiControllerWidgetMainContainer multiControllerWidgetMainContainer_${listItemData[0].widgetMetaHtmlId} multiControllerWidgetMainContainer_${listItemData[0].id}`}
        >
            <CustomFlatList
                nestedScrollEnabled={true}
                data={listItemData}
                renderItem={renderItem}
                keyExtractor={item => item?.widgetId?.toString()}
                showsVerticalScrollIndicator={false}
            />
        </View>
    );
}

export default MultiControllerWidget;
